/**
 * BugReportModal Component
 * In-app bug reporting: a short description plus auto-captured context
 * (current URL, browser user agent, username, timestamp) — the user
 * shouldn't have to type any of that themselves.
 */

import React, { useState } from 'react';
import axios from 'axios';
import './BugReportModal.css';

function BugReportModal({ onClose }) {
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!description.trim()) {
      setError('Please describe the issue');
      return;
    }

    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bug-report`,
        {
          description: description.trim(),
          url: window.location.href,
          userAgent: navigator.userAgent
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content bug-report-modal" onClick={(e) => e.stopPropagation()}>
          <div className="success-container">
            <div className="success-icon">✓</div>
            <h2>Thank You</h2>
            <p>Your bug report has been submitted.</p>
            <button onClick={onClose} className="btn-primary">
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content bug-report-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Report a Bug</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <p className="modal-description">
          Describe what happened, what you expected, and the steps to reproduce it if
          you can. The current page and your browser info are included automatically.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="bug-description">
              Description <span className="required">*</span>
            </label>
            <textarea
              id="bug-description"
              rows="6"
              value={description}
              onChange={(e) => { setDescription(e.target.value); if (error) setError(''); }}
              placeholder="e.g., Clicking 'Preview Report' on the Renal form does nothing..."
              autoFocus
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="button-group">
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Sending...' : 'Submit Report'}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary" disabled={loading}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default BugReportModal;
